import { Dialog } from "@sundae/ui-toolkit";
import { IMappedAsset } from "@sundae/wallet-react";
import { AssetAmount } from "@sundaeswap/asset";
import React, { ReactNode, memo } from "react";

import { joyrideSelectors } from "../../../constants/joyride.constants";
import { testIds } from "../../../constants/testIds.constants";
import { TAssetSelectContext } from "../../../hooks/useAssetSelect";
import { IAssetMetaData } from "../../../types/Asset.types";
import AssetSelectFlow from "../../AssetSelectFlow";

export interface IAssetSelectDialogProps {
  activeAsset?: AssetAmount<IAssetMetaData> | null;
  assets: IMappedAsset<IAssetMetaData>[];
  autoFocusSearch?: boolean;
  context?: TAssetSelectContext;
  copy: string;
  isLoading: boolean;
  onAssetSelect?(asset: IMappedAsset<IAssetMetaData>): void;
  onClose(): void;
  open: boolean;
  renderNoSearchResults?: ReactNode;
  searchPlaceholder?: string;
  title: string;
}

const AssetSelectDialog: React.FC<IAssetSelectDialogProps> = ({
  activeAsset,
  assets,
  autoFocusSearch = true,
  context,
  copy = "Search for a token by name or policy ID.",
  isLoading,
  onAssetSelect,
  onClose,
  open,
  renderNoSearchResults,
  searchPlaceholder = "Search token…",
  title = "Select Token",
}) => {
  return (
    <Dialog
      closeDialog={onClose}
      description={copy}
      open={open}
      title={title}
      testId={testIds.assetSelectDialog.content}
      primitiveProps={{
        content: {
          // @ts-ignore --> ignoring because this is a custom prop; TODO: allow in toolkit
          "data-guide-selector": joyrideSelectors.guides.exchange.assetSelectDialog,
        },
      }}
    >
      <AssetSelectFlow
        activeAsset={activeAsset}
        assets={assets}
        autoFocusSearch={autoFocusSearch}
        context={context}
        isLoading={isLoading}
        onAssetSelect={onAssetSelect}
        renderNoSearchResults={renderNoSearchResults}
        searchPlaceholder={searchPlaceholder}
      />
    </Dialog>
  );
};

export default memo(AssetSelectDialog);
